import { render, staticRenderFns } from "./InventoryChangeReport.vue?vue&type=template&id=384748b3&scoped=true"
import script from "./InventoryChangeReport.vue?vue&type=script&lang=js"
export * from "./InventoryChangeReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryChangeReport.vue?vue&type=style&index=0&id=384748b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384748b3",
  null
  
)

export default component.exports